import DefaultError from './DefaultError.js'
import { BlogError1, BlogError2 } from './BlogError.js'

export default {
    DefaultError,
    BlogError1,
    BlogError2
}